export { Casa } from './Casa';
export { Estudios } from './Estudios';
export { Herencia } from './Herencia';
export { Impuestos } from './Impuestos';
export { Invertir } from './Invertir';
export { Jubilacion } from './Jubilacion';
